<app-header />

<app-navbar />

<router-outlet />

<app-footer />

<app-loading-indicator />

<app-toaster />
